import { cn } from "@synthesis/shared-utils";

export const ACCESS_DENIED_MESSAGE = "У вас нет доступа";
export const PROJECT_ACCESS_DENIED_MESSAGE = "У вас нет доступа к этому проекту";

type AccessDeniedProps = {
  message?: string;
  className?: string;
};

export const AccessDenied = ({ message = ACCESS_DENIED_MESSAGE, className }: AccessDeniedProps) => (
  <div className={cn("flex h-[calc(100vh-70px)] flex-col items-center justify-center px-8", className)}>
    <p className="text-type-light text-xl">{message}</p>
  </div>
);
